class Routing {
  static exps = null;

  static R = (segment) => {
    Routing.exps = Routing.exps || (window.site_config || {}).routing || [];    

    return (Routing.exps.find(f => f.segment === segment) || { translated: segment }).translated;
  }
}

export { Routing };